import { render, staticRenderFns } from "./CalculationRequestResults.vue?vue&type=template&id=8495bc04&"
import script from "./CalculationRequestResults.vue?vue&type=script&lang=js&"
export * from "./CalculationRequestResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports